var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex position-relative"
  }, [_c('BaseInputText', {
    staticClass: "w-100 h-100",
    attrs: {
      "name": "searchQuery",
      "autocomplete": "off",
      "placeholder": _vm.searchLabel
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search.apply(null, arguments);
      },
      "input": _vm.searchForAutocomplete
    },
    model: {
      value: _vm.searchQuery,
      callback: function ($$v) {
        _vm.searchQuery = $$v;
      },
      expression: "searchQuery"
    }
  }), _c('MottoIcon', {
    class: _vm.$style.searchIcon,
    attrs: {
      "name": "Search"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.search.apply(null, arguments);
      }
    }
  }), _c('ResourceSearchSuggestion', {
    class: _vm.$style.searchSuggestions,
    attrs: {
      "resources": _vm.autocompleteResults,
      "search-query": _vm.searchQuery
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }